import { STATS_SERVICE } from "@/services/stats.service.js";
import router from '@/router/index';

const state = { statsOutput: {} };

const actions = {
    getStats({ dispatch, commit }, languageCode) {
        dispatch('alert/clear', null, { root: true });
        commit('getRequest');

        STATS_SERVICE.get(languageCode)
            .then(
                output => {
                    commit('getSuccess', output);
                },
                error => {
                    commit('getFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    /* Get */
    getRequest(state) {
        //
    },
    getSuccess(state, output) {
        state.statsOutput = output;
    },
    getFailure(state) {
        state.statsOutput = {};
    },
};

export const stats = {
    namespaced: true,
    state,
    actions,
    mutations
};